export default "__VITE_ASSET__9f7XhA3d__"